import styled from 'styled-components'

export const TitleField = styled.div`
  padding-top: 10%;
  `